import { NgClass } from '@angular/common'
import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { ClickStopPropagationDirective } from '../../../directives'
import { NavigationItem, NavigationLayout } from '../navigation.component'

@Component({
  selector: 'lib-navigation-button',
  imports: [NgClass, RouterModule, MatButtonModule, MatIconModule, MatBadgeModule, MatTooltipModule, ClickStopPropagationDirective],
  templateUrl: './navigation-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './navigation-button.component.scss',
})
export class NavigationButtonComponent {
  readonly navItem = input.required<NavigationItem>()
  /** Bekommt nur das aufgeloeste Layout (`rail` oder `list`), nie `responsive`. */
  readonly layout = input<NavigationLayout>('rail')
  /** Leiste ohne Beschriftung, siehe `NavigationComponent.nurIcons`. Nur im `rail`-Layout wirksam. */
  readonly nurIcons = input(false)
}
